import { configureStore } from '@reduxjs/toolkit';

// Import your slices here
// import exampleReducer from './slices/exampleSlice';

// Temporary placeholder reducer until you add your actual reducers
const placeholderReducer = (state = {}, action: any) => state;

export const store = configureStore({
  reducer: {
    // Add your reducers here
    // example: exampleReducer,
    _placeholder: placeholderReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
